import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      textTransform: 'capitalize',
      color: COLORS.neutral.blackBlue,
      display: 'flex',
      alignItems: 'center',
      columnGap: theme.spacing(1),
    },
    title: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(22),
      fontWeight: theme.typography.fontWeightMedium,
      '& span': {
        color: COLORS.gray.gray50,
      },
    },
    icon: {
      fontSize: theme.typography.pxToRem(24),
      lineHeight: theme.typography.pxToRem(24),
    },
  }),
  { name: 'VariationFormat' }
);
